
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('../../node_modules/jquery-mask-plugin/dist/jquery.mask.min.js');
require('../../node_modules/air-datepicker/dist/js/datepicker.js');
require('../../node_modules/magnific-popup/dist/jquery.magnific-popup.min.js');
require('../../node_modules/sweetalert2/src/sweetalert2.js');
require('./datepicker.tr.js');

// window.Vue = require('vue');


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Vue.component('example-component', require('./components/ExampleComponent.vue'));

// const app = new Vue({
//     el: '#app'
// });


// if ($("body").height() > $(window).height()) {
//     $(".navbar-laravel").addClass("fixed-top");
// }


$("#dob").datepicker({
    language: 'tr',
    dateFormat: 'yyyy-mm-dd',
    view: 'years',
    maxDate: new Date('1989-12-31'),
    minDate: new Date('1940-01-01')
});

var removeDocLink;
$("#removeDoctor").click(function(){
    removeDocLink = $(this).attr("href");
    Swal.fire({
        title: 'Emin misiniz?',
        text: "Bu işlem geri alınamaz.",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Eşleşmeyi kaldır'
    }).then((result) => {
        if (result.value) {
            window.location = removeDocLink;
        }
    });

    return false;
});

if ($("#dob").length > 0 && $("#dob").val() != "") {
    var deyt = new Date($("#dob").val());
    $("#dob").datepicker().data('datepicker').selectDate(deyt);
}


$(".timespan").change(function(){
    var url = $(this).val(); // get selected value
    if (url) { // require a URL
        window.location = url; // redirect
    }
    return false;
});

$(document).ready(function() {
  $('.open-popup-link').magnificPopup({type:'image'});
});


$('.image-popup-gallery').each(function() { // the containers for all your galleries
    $(this).magnificPopup({
        delegate: 'a', // the selector for gallery item
        type: 'image',
        gallery: {
          enabled:true
        }
    });
});



// WEBPACK FOOTER //
// ./resources/js/app.js